var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2498 27.125C25.104 27.1041 24.9165 27.1041 24.7498 27.125C21.0832 27 18.1665 24 18.1665 20.3125C18.1665 16.5416 21.2082 13.4791 24.9998 13.4791C28.7707 13.4791 31.8332 16.5416 31.8332 20.3125C31.8123 24 28.9165 27 25.2498 27.125Z",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0418 40.8751C35.3335 44.271 30.4168 46.3335 25.0002 46.3335C19.5835 46.3335 14.6668 44.271 10.9585 40.8751C11.1668 38.9168 12.4168 37.0001 14.646 35.5001C20.3543 31.7085 29.6877 31.7085 35.3543 35.5001C37.5835 37.0001 38.8335 38.9168 39.0418 40.8751Z",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9998 46.3333C36.5058 46.3333 45.8332 37.0059 45.8332 25.5C45.8332 13.994 36.5058 4.66663 24.9998 4.66663C13.4939 4.66663 4.1665 13.994 4.1665 25.5C4.1665 37.0059 13.4939 46.3333 24.9998 46.3333Z",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileCircle);
export default __webpack_public_path__ + "static/media/profile-circle.6df2db87323439909569198d84483139.svg";
export { ForwardRef as ReactComponent };